import { useState, useEffect, useMemo } from "react";

import './Clients.css';

import { GetDataPage, RegisterDataPage, UnRegisterDataPage } from "../../interface/Data";
import { Svg_Delete, Svg_Disable, Svg_Edit, Svg_Link, Svg_Search, Svg_Undo } from "../../components/Svg";
import { Input_Text } from "../../components/Input";

import { AltStatus } from "../../services/Function";
import { OpenPage } from "../../services/OpenPage";

interface DataClient {
    id             : string;
    version_        : string;
    status         : number;
    file           : string;
    comporate_name : string;
    name_link      : string;
    qtd_projects   : string;
    login_name     : string;
    login_email    : string;
    bd_name        : string;
    subdominio     : string;
    date_to_delete : string | null;
    register_id    : string;
    register_date  : string;
    removed_id     : string;
    removed_date   : string | null;
}

export default function Page_Clients() {

    const [ listData, setListData ] = useState<{ [key: string]: DataClient }>(GetDataPage("clients") || {});
    const [ search, setSearch ] = useState('');

    const dataPage = useMemo(() => {
        const list = Object.keys(listData);
        if(search === ''){
            return list;
        }

        const text = search.toLowerCase();
        return list.filter((elem)=>{
            const showInf = listData[elem];
            return (showInf.comporate_name || '').toLowerCase().includes(text) ||
                (showInf.login_name || '').toLowerCase().includes(text) ||
                (showInf.login_email || '').toLowerCase().includes(text);
        });
    }, [listData, search]);

    useEffect(() => {
        RegisterDataPage("clients", setListData);
        return () => { UnRegisterDataPage("clients", setListData); };
    }, []);

    return (
        <div className="page_data_list Page_Clients">
            <div className="div_search">
                <div className="div_input">
                    <Svg_Search className="icons icon_search" color="#B1B2B2" />
                    <Input_Text title="Search" type="text" value={ search } setValue={ setSearch } placeholder="Search by client" required={ false } />
                </div>
            </div>

            <table cellPadding={ 0 } cellSpacing={ 0 }>
                <thead>
                    <tr>
                        <th align="center" style={ { width: "20px" } }>#</th>
                        <th>Company</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th style={ { width: "30px" } }>Version</th>
                        <th style={ { width: "80px" } }>Qtd. of Projects</th>
                        <th align="right" style={ { width: "20px" } }>#</th>
                    </tr>
                </thead>
                <tbody>
                    {                        
                        dataPage.length > 0 ?
                            dataPage.map((elem, index) => {
                                const showInf = listData[elem];

                                const textStatus  = showInf.status === 1
                                    ? `Are you sure you want to disable the client "${ showInf.comporate_name }"?`
                                    : `Are you sure you want to enable the client "${ showInf.comporate_name }"?`;

                                const classStatusTD = showInf.status === 0 ? 'disabled_td' : '';
                                const classStatus   = showInf.status === 0 ? 
                                    'data_disabled' : showInf.status === 2 ? 'data_delete' : '';

                                const titleDisable  = showInf.status === 1 ? "Disable client" : "Enable client";
                                const textDelete    = showInf.status === 2 ? `Are you sure you want to delete the client "${ showInf.comporate_name }"?` : `Are you sure you want to cancel the customer removal "${ showInf.comporate_name }"?`;
                                const textStatusDelete = showInf.status === 2 ? "Reactivate client" : "Delete client";

                                return (
                                    <tr key={ elem } className={ classStatus }>
                                        <td align="center">{ index + 1 }</td>
                                        <td className={ classStatusTD }>                                            
                                            <div className="div_img_td">
                                                {
                                                    showInf.file ?
                                                        <div className="img_td" style={ { backgroundImage: `url("${ showInf.file }")` } } />
                                                    :
                                                    null
                                                }
                                                <div>{ showInf.comporate_name }</div>
                                            </div>
                                        </td>
                                        <td className={ classStatusTD }>{ showInf.login_name }</td>
                                        <td className={ classStatusTD }>{ showInf.login_email }</td>
                                        <td className={ classStatusTD } align="center">{ showInf.version_ }</td>
                                        <td className={ classStatusTD } align="center">{ showInf.qtd_projects }</td>
                                        <td className={ classStatusTD } align="center">
                                            <div className="list_opt">
                                                <div data-tooltip-id="show_alert" data-tooltip-content="Click here to open the link." data-tooltip-place="top" onClick={ ()=>{ window.open(showInf.subdominio, '_blank', 'noopener, noreferrer') } }>
                                                    <Svg_Link className="icons" color="#B1B2B2" />
                                                </div>

                                                <div data-tooltip-id="show_alert" data-tooltip-content={ titleDisable } data-tooltip-place="top" onClick={ ()=>{ AltStatus('clients', titleDisable, 'disable_enable', showInf.id, textStatus, showInf.status === 1 ? "0" : "1") } }>
                                                    <Svg_Disable className="icons" color={ showInf.status ? "#B1B2B2" : "#FF0000" } />
                                                </div>

                                                <div data-tooltip-id="show_alert" data-tooltip-content={ textStatusDelete } data-tooltip-place="top" onClick={ ()=>{ AltStatus('clients', textStatusDelete, showInf.status === 2 ? 'reactivate' : 'delete', showInf.id, textDelete, "2") } }>
                                                    {
                                                        showInf.status === 2 ?
                                                            <Svg_Undo className="icons" color="#B1B2B2" />
                                                        :
                                                        <Svg_Delete className="icons" color="#B1B2B2" />
                                                    }
                                                </div>

                                                <div data-tooltip-id="show_alert" data-tooltip-content="Edit client" data-tooltip-place="top" onClick={ ()=>{ OpenPage('clients_details', showInf.id); } }>
                                                    <Svg_Edit className="icons" color="#B1B2B2" />
                                                </div>
                                            </div>
                                            {
                                                showInf.status === 2 ? 
                                                    <div className="div_status_delete" data-tooltip-id="show_alert" data-tooltip-content={ `It will be deleted on ${ showInf.date_to_delete }` } data-tooltip-place="top">
                                                        { showInf.date_to_delete }
                                                    </div>
                                                : null
                                            }
                                        </td>
                                    </tr>
                                );
                            })
                        :
                        <tr>
                            <td colSpan={ 6 } align="center">No data found</td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    );
}